import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice"; 

const { TextArea } = Input;

const AddShiftRequestModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { shiftType } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [shiftName,setShiftName] =  useState()


  const onFinish = async (data) => {
    data.shrNewShift = shiftName
    const res = await dispatch(
      save({
        shrId: prodd?.shrId ? prodd?.shrId : null,
        ...data,
        url: "self/saveShiftRequest.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData(); 
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };


  useEffect(() => {
    if (prodd) {
      form.setFieldsValue(prodd)
    } else {
      form.resetFields();
    }
  }, [prodd, form]);
 

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit shift request ${prodd?.shrNewShift}`
            : "Add shift request details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
            <Form.Item
              name="shrNewShiftId"
              className=""
              label={<span>Shift Type</span>}
              rules={[
                {
                  required: true,
                  message: "Please select personnel",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  shiftType?.length > 0 &&
                  shiftType?.map((item) => ({
                    value: item?.stId,
                    label:item?.stName  
                  }))
                }
                onChange={(value) => {
                  const selectedItem = shiftType?.find(
                    (item) => item?.stId === value
                  );
                  setShiftName(selectedItem?.stName || "");
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }  
              />
            </Form.Item>
            <Form.Item
            name="shrComments"
            label="Comments"
            rules={[
              {
                required: true,
                message: "Enter comments",
              },
            ]}
          >
            <TextArea  rows={6} className="input" />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddShiftRequestModal;
